import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function newsletterReducer(
  state = initialState.NewsletterData,
  action
) {
  if (action.type === types.LOAD_NEWSLETTER_DATA_SUCCESS) {
    return action.NewsletterData;
  }
  return state;
}
